import clsx from 'clsx'
import type { CSSProperties } from 'react'
import { PHASE_TRANSITION_ICONS_STELE_TOP_VIEWPORT } from '@/src/game/ui/banner/parentsInfoBannerConstants'

export type PhaseTransitionIconPlacement = 'viewport' | 'hud'

export function getPhaseTransitionIconsClassName(
    isStele: boolean,
    placement: PhaseTransitionIconPlacement,
) {
    return clsx(
        'top-8 left-1/2 absolute flex justify-center items-center gap-2 -translate-x-1/2',
        'stele:gap-6',
        placement === 'hud' && isStele && 'stele:top-16',
    )
}

export function getPhaseTransitionIconsStyle(
    isStele: boolean,
    placement: PhaseTransitionIconPlacement,
): CSSProperties | undefined {
    if (!isStele || placement !== 'viewport') {
        return undefined
    }

    return { top: PHASE_TRANSITION_ICONS_STELE_TOP_VIEWPORT }
}
